<!-- <template>  
    <div>  
        <div class="requestverifyPage mt-5 pt-md-3 text-center">
            <div class="stepForm" v-if="success == '3'">
            <div class="CustomBlockWidth inMiddle-area whitebox p-4">  
                <div class="congratulations">
                    <div class="faildeLoader mt-5">
                        <h3>Request is processing.....</h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="stepForm" v-if="success == true">
            <div class="mainTitle text-center mt-4 mb-3"> 
                <h3 class="mb-4">Request Verify</h3>
            </div> 
            <div class="CustomBlockWidth inMiddle-area whitebox p-4">   
                <div class="congratulations">
                    <div class="logo_congrats">
                    </div>
                    <div class="subtitle">
                        <p>{{msg}}</p> 
                    </div>
                    <div class="signupbtn full-width submitButton w-100 mt-4 text-center accounts_mainsec">
                        <router-link :to="'/withdrawal-list'" class="prism_btn btn_sm">Back to withdrawal list</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="stepForm text-center" v-if="success == false">
            <div class="requestFailPic">
            </div>
            <div class="mainTitle text-center mb-3"> 
                <h3 class="failedStatus">Request Failed!</h3>
            </div>
            <div class="CustomBlockWidth inMiddle-area whitebox p-4">   
                <div class="congratulations submitRequest">
                    <div class="subtitle">
                        <p>{{msg}}</p> 
                    </div>
                    <div class="signupbtn full-width submitButton w-100 mt-4 text-center accounts_mainsec">
                         <router-link :to="'/manage-funds'" class="prism_btn btn_sm">Back to withdrawal list</router-link>
                    </div>
                </div>
            </div> 
        </div>
        </div>
    </div> 
</template> -->
<style>
.responseBox {
  align-items: center;
  justify-content: center;
  padding: 2%;
  max-width: 50%;
  text-align: center;
}
.successBox {
  background-color: green;
}
.errorBox {
  background-color: red;
}
.responseBox p {
  color: white;
  margin-bottom: 0;
  margin-top: 20px;
}
</style>
<template>
  <div id="main-wrapper">
    <div
      class="content-container dashboard-page"
      style="
        min-height: 500px;
        display: flex;
        align-items: center;
        justify-content: center;
      "
    >
      <p v-if="response == -1">{{$t("request_verify.verifying_your_request")}}...</p>
      <div class="responseBox successBox" v-if="response == 1">
        <h3>{{$t("request_verify.success")}}</h3>
        <p>{{ msg }}</p>
        <router-link :to="{path : '/manage-funds',query:{'from' : 'verifyWithdrawal'}}" class="btn btn-blue">{{$t("request_verify.go_to_transactions")}}</router-link>
      </div>
      <div class="responseBox errorBox" v-if="response == 0">
        <h3>{{$t("request_verify.error")}}</h3>
        <p>{{ msg }}</p>
      </div>
    </div>
  </div>
</template>
<script>
    import { useMainStore } from "@/store";
    export default {
        name: 'Withdrawal',
       setup() {
        const store = useMainStore();
        return { store };
      },
        data() {
            return {
               verify : '',
              response: -1,
               msg: null,
            }
        },
        created(){
            let query = Object.assign({}, this.$route.query);
            if(this.$route.query.verify){
                this.verify = query.verify
                let form = {
                    'verify' : this.verify.toString(),
                    "type" : 'WITHDARWAL'
                };
                this.store.verifyAccountOperation(form,true).then(() => {
                  this.response = 1;
                  this.msg = `Your withdrawal request has been processed successfully`
                })
                .catch((error) => {
                  this.response = 0;
                  this.msg = error;
                });
                delete query.verify;
                this.$router.replace({ query });
            }else{
              this.$router.push("/dashboard");
            }
        }
    }
</script>